export default __webpack_public_path__ + "f9e0656c617bd89849262c73e8812922.png";